Vue.component('Block', require('./Block.vue'));
Vue.component('Index', require('./Index.vue'));
Vue.component('ActivityLog', require('./ActivityLog.vue'));
Vue.component('Subheader', require('./Subheader.vue'));

Vue.component('FormArrayInput', require('./form/ArrayInput.vue'));
Vue.component('FormInput', require('./form/Input.vue'));
Vue.component('FormInputTrans', require('./form/InputTrans.vue'));
Vue.component('FormTextareaTrans', require('./form/TextareaTrans.vue'));
Vue.component('ColumnRelation', require('./table/header/ColumnRelation.vue'));
Vue.component('ColumnSelect', require('./table/header/ColumnSelect.vue'));
Vue.component('ColumnBoolean', require('./table/header/ColumnBoolean.vue'));
Vue.component('BooleanTransHeader', require('./table/header/BooleanTransHeader.vue'));
Vue.component('BooleanHeader', require('./table/header/BooleanHeader.vue'));
Vue.component('DateRange', require('./table/header/DateRange.vue'));
Vue.component('ColumnSearch', require('./table/header/ColumnSearch.vue'));
Vue.component('PanelPropertyActionsHeader', require('./table/header/PanelPropertyActionsHeader.vue'));

Vue.component('UsersTableValue', require('./table/value/Users.vue'));
Vue.component('CreatedBy', require('./table/value/CreatedBy.vue'));
Vue.component('BooleanYesNo', require('./table/value/BooleanYesNo.vue'));
Vue.component('BooleanColorDot', require('./table/value/BooleanColorDot.vue'));
Vue.component('BooleanTransColorDot', require('./table/value/BooleanTransColorDot.vue'));
Vue.component('Date', require('./table/value/Date.vue'));
Vue.component('Translatable', require('./table/value/Translatable.vue'));
Vue.component('TableImage', require('./table/value/TableImage.vue'));
Vue.component('TableValueArray', require('./table/value/Array.vue'));
Vue.component('PropertyImage', require('./table/value/panel/PropertyImage.vue'));

Vue.component('LinkToPage', require('./table/value/links/Page.vue'));
Vue.component('LinkToBlog', require('./table/value/links/Blog.vue'));
Vue.component('LinkToProperty', require('./table/value/links/Property.vue'));
Vue.component('LinkToCompany', require('./table/value/links/Company.vue'));


Vue.component('SlugInput', require('./form/SlugInput.vue'));

Vue.component('PanelPropertyActions', require('./table/value/panel/PropertyActions.vue'));


// WEBPACK FOOTER //
// ./resources/js/metronic/index.js